import { axiosInstance } from "../../utils/axios";
import { CpmUserResponse } from "../models/cpm-user-response";

export function fetchCpmUser(): Promise<CpmUserResponse> {
  return axiosInstance.get(`/cpmuser`).then((resp) => resp.data);
}
